import { graphql } from "gatsby"
import { EntryScreen } from "../components/screens"

const IndexPage = ({ data }) => {
  return <EntryScreen entry={data.entry} />
}

export default IndexPage

export const query = graphql`
  query HomeQuery {
    entry: craftHomeHomeEntry {
      ...homeEntry
    }
  }
`
